import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core'

const InterestConfirmedDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} disableRestoreFocus>
    <DialogContent>
      <DialogContentText>
        Sua confirmação foi registrada com sucesso!
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        ok
      </Button>
    </DialogActions>
  </Dialog>
)

export default InterestConfirmedDialog
